"use client"

import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import classNames from "classnames";

import { CSSTransition } from "react-transition-group";

import { AppTopbar } from "../AppTopbar";
import { AppFooter } from "../AppFooter";
import { AppMenu } from "../AppMenu";
import { AppConfig } from "../AppConfig";
import TabBarContainer from "../components/tabs/TabBar";

import { PlantillaService } from '../service/PlantillaService';

import AuthController from '../controller/AuthController';

import PrimeReact from "primereact/api";
import { Tooltip } from "primereact/tooltip";
import { useTimout } from 'primereact/hooks';
import { useInterval } from 'primereact/hooks';

import { selectTab } from "../components/tabs/tabsActions";
import TemplateContent from "./TemplateContent";
import { Toast } from 'primereact/toast';

import ChartDemo from '../components/ChartDemo';
import HomeDemo from '../components/HomeDemo';

import AuthStorage from '../storage/AuthStorage';

import "primereact/resources/primereact.css";
import "primeicons/primeicons.css";
import "primeflex/primeflex.css";
import "prismjs/themes/prism-coy.css";
import "../assets/demo/flags/flags.css";
import "../assets/demo/Demos.scss";
import "../assets/layout/layout.scss";
import "../App.scss";
//import { render } from "preact/compat";

import { verifySubdomainBase, verifyUser } from '../routes/ConfigSubdomain';

const TemplateLandingPageGuest = (props) => {

    console.log("TemplateLandingPageGuest.js");
    verifySubdomainBase();
    //verifyUser();

    

    const [comodin, setComodin] = useState(0);

    const tabs = useRef([]);
    const toast = useRef();

    const authStorage = new AuthStorage(window.location.pathname);
    const authController = new AuthController();

    const plantillaService = new PlantillaService();

    let dataConfigSubdomain = authStorage.getConfigSubdomain();
    let { subdomain, idSuscripcion, idEmpresaInit, idiomaInit, urlLogoLogin } = dataConfigSubdomain;

    const userDetails = authStorage.GetCurrentUser();
    let { userName, idEmpresa, idioma, sessionGUID, documentoInvitado } = userDetails;

    useEffect(() => {
    }, [comodin]);


    useEffect( () => {

        if (1 == 0 && userName === undefined) {

            const formVisit = {
                idSuscripcion: idSuscripcion,
                idioma: idiomaInit,
                idEmpresa: idEmpresaInit,
                subdomain: subdomain,
                userName: 'visit',
                password: ''
            };

            let response =  authController.loginUser(formVisit) //loginUser action makes the request and handles all the neccessary state changes
            console.log("responseVisit111, ", response);

            const userDetails = authStorage.GetCurrentUser();
            userName = userDetails.userName;
            idEmpresa = userDetails.idEmpresa;
            idioma = userDetails.idioma;
            sessionGUID = userDetails.sessionGUID;
            documentoInvitado = userDetails.documentoInvitado;

        }

        if (userName !== undefined && userName !== "visit") {

        }

    }, []);


    return (<>
        {props.children}
    </>
    );

};

export default connect(null)(TemplateLandingPageGuest);
